import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import CloseIcon from 'assets/closeOutline.svg'
import useTranslations from 'hooks/useTranslations'

type Props = {
  setShowModal: (val: boolean) => void
}

export default function Modal(props: Props) {
  const t = useTranslations<'molecules-account-CartSummary'>()

  return (
    <Wrapper>
      <div
        data-cy-handle="close-modal-btn"
        onClick={() => props.setShowModal(false)}
        className="headline-close"
      >
        <CloseIcon />
      </div>
      <div className="headline">
        <div>{t('sharecart_errormodal_import_failed')}</div>
      </div>
      <div className="sub-text">
        {t('sharecart_errormodal_import_failed_explanation')}
      </div>
      <div className="list">
        <div
          className="btn close"
          data-cy-handle="close-modal-btn"
          onClick={() => props.setShowModal(false)}
        >
          {t('sharecart_errormodal_close')}
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  ${theme._ty([13, 0, 18], theme.font, '400')}
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: ${theme.zIndex
    .theme_molecules_account_cartsummary_sharecart_errormodal_modal};
  width: calc(100% - 2.5rem);
  padding: ${theme.spacing('m')} ${theme.spacing('m')};
  background-color: ${theme.colors.shade.b7};
  @media (min-width: ${theme.ms.MD}px) {
    ${theme._ty([16, 0, 24], theme.font, '400')}
  }

  @media (min-width: ${theme.ms.SM}px) {
    width: calc(100% - 5rem);
  }

  @media (min-width: ${theme.ms.MD}px) {
    width: 37.5rem;
  }

  @media (min-width: ${theme.ms.LG}px) {
    width: 51.25rem;
  }

  > .headline-close {
    display: flex;
    justify-content: end;
    margin-bottom: -${theme.spacing('xs')};
    cursor: pointer;
  }

  > .headline {
    ${theme._ty([16, 0, 22], theme.fontSpecial, '700')}
    margin-bottom: ${theme.spacing('xs')};
    @media (min-width: ${theme.ms.MD}px) {
      ${theme._ty([22, 0, 28], theme.fontSpecial, '700')}
    }
  }
  > .sub-text {
    margin-bottom: ${theme.spacing('m')};
  }

  > .list {
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing('xs')};
    @media (min-width: ${theme.ms.MD}px) {
      flex-direction: row;
    }
    > .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: ${theme.spacing('s')};
      ${theme._ty([16, 0, 22], theme.fontSpecial, '700')}
      color: ${theme.colors.shade.b2};
      border: 1px solid ${theme.colors.shade.b3};
      ${theme.rounding('m')}
      cursor: pointer;
    }

    > .close {
      color: ${theme.colors.b0};
      border: 0;
      padding-top: ${theme.spacing('xxs')};
      padding-bottom: 0;

      @media (min-width: ${theme.ms.MD}px) {
        display: none;
      }
    }
  }
`
